import { userDetails, UserDetails } from "../store/IntialStore";
import * as types from "../action/ActionType";

interface UserAction {
  type: string;
  payload: UserDetails;
  userName?: string;
}

export default function UserReducer(
  state: UserDetails = userDetails,
  action: UserAction
): UserDetails {
  const { type, payload, userName } = action;
  switch (type) {
    case types.ADD_USER_PROFILE:
      return payload;
    case types.UPDATE_USER_PROFILE:
      return {
        ...userDetails,
        profilePic: payload as unknown as string,
        userName: userName ?? null,
      };
    default:
      return state;
  }
}
